import actionCreator from '../../../utils/actionCreator';

const homeActionTypes = ['GET_HOME_STAT', "GET_QUEUE", 'GET_ONBOARDING', 'GET_WRAPPED_STATS'];

export const { types: homeTypes, actions: homeActions } = actionCreator(homeActionTypes);
